export default __webpack_public_path__ + "static/metalwax-5431e746ba55eb76867b4b87895015d4.png";